import 'theme/fonts/Inter/inter.css';

const variables = {
  colorPrimaryMain: '#3E3B57',
  colorTextPrimary: '#15181d',
  colorTextSecondary: '#636870',
  colorTextDisabled: '#a6abb2',
  colorNeutralMain: '#074eb8',
  colorPrimaryDark: '#2B293D',
  colorPrimaryLight: '#EAE9F6',
  iconPrimaryFill: '#3E3B57',
  iconSecondaryFill: '#2B293D',
  iconThirdFill: '#EAE9F6',
  colorNeutralDark: '#c9ccd1',
  colorErrorMain: '#dd1d00',
  colorErrorLight: '#fff4f0',
  colorBackgroundLight: '#f9f9fa',
  colorSuccessMain: '#008442',
  colorDarkGray: '#404040',
  colorSecondaryLight: '#3b3b3b',
  colorPurpleLight: '#f7e5ff',
  colorPurpleDark: '#9909E0',
  colorSuccessBg: '#e9ffd7',
  colorDiesel: '#312c2c',
  colorErrorDark: '#ffe6e6',
  colorGreen90: '#247F6A',
  colorWhite: '#fff',
  colorBorder: '#e6e7e9',
  colorFormInvalid: '#f65260',
  colorFormInvalidBorder: '#f75c',
  colorLinkBlue: '#2fa6f8',
  colorAsh80: '#00000014',
  colorButtonBackground: '#E6E7E9',
  colorCreditScoreVeryPoor: '#F63C45',
  colorCreditScorePoor: '#FFA51F',
  colorCreditScoreFair: '#E8DB21',
  colorCreditScoreGood: '#A3CC28',
  colorCreditScoreVeryGood: '#1A894C',
  colorErrorStatus: '#E00909',

  /* Carousel banner styles */
  colorStartGradientBanner: '#EAE9F6',
  colorMiddleGradientBanner: '#D0CFDE',
  colorEndGradientBanner: '#EAE9F6',
  /* End of Carousel banner styles */

  fontFamily: 'Inter, sans-serif',
  fontH32: '600 32px/1.5 Inter, sans-serif',
  fontH24: '600 24px/1.5 Inter, sans-serif',
  fontH20: '600 20px/1.6 Inter, sans-serif',
  fontH18: '600 18px/1.55 Inter, sans-serif',
  fontH16: '600 16px/1.5 Inter, sans-serif',
  fontH14: '500 14px/1.57 Inter, sans-serif',
  fontH12: '500 12px/1.5 Inter, sans-serif',
  fontH10: '600 10px/1.6 Inter, sans-serif',
  fontP18: '400 18px/1.55 Inter, sans-serif',
  fontP16: '400 16px/1.5 Inter, sans-serif',
  fontP14: '400 14px/1.57 Inter, sans-serif',
  fontP12: '400 12px/1.5 Inter, sans-serif',
  fontP10: '400 10px/1.6 Inter, sans-serif',

  boxShadow: '0 0.25rem 1rem 0 rgba(0, 0, 0, 0.08)',
  logoHeight: '56px',
};

export default variables;
